import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_CHANNELS_ACTION_TYPE } from '../actions';

const initialState = [];

const subCompanyChannelsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_CHANNELS_ACTION_TYPE.GET_CHANNELS:
        return payload || initialState;

      case SUB_COMPANY_CHANNELS_ACTION_TYPE.ADD_CHANNEL:
        draft.push(payload);
        break;

      case SUB_COMPANY_CHANNELS_ACTION_TYPE.REMOVE_CHANNEL:
        return draft.filter(channel => channel.channelId !== meta.channelId);

      case SUB_COMPANY_CHANNELS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyChannelsReducer;
